'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (props) {
    return _react2['default'].createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/table/FilterDropdownMenuWrapper.js
 ** module id = 511
 ** module chunks = 0
 **/